import React from 'react';
import { useTranslation } from 'react-i18next';
import { Utils } from '../../services';
import SelectField from '../SelectField/SelectField';
import MultiSelectField from '../MultiSelectField/MultiSelectField';

import './ScreeningsField.css';

const screening_option_id = (screening) => screening?._id || screening?.id;

const ScreeningsField = ({ name, screenings, placeholder, single, onSelectChange, parse }) => {
    const { i18n } = useTranslation();
    const options = (screenings || []).map(screening => {
        const id = screening_option_id(screening);
        return {
            key: id,
            text: [
                Utils.localized_or_fallback(screening.title, i18n.language),
                screening.start_at ? Utils.formatLocalizedDateTime(screening.start_at, i18n.language, 'LLL') : '',
            ].filter(Boolean).join(' - '),
            value: id
        };
    });

    return single ? (
        <SelectField
            name={ name }
            options={ options }
            placeholder={ placeholder }
            clearable
            searchable="true"
            onSelectChange={ onSelectChange }
            parse={ parse }
        />
    ) : (
        <MultiSelectField name={ name } options={ options } placeholder={ placeholder } clearable />
    );
}

export default ScreeningsField;
